import React, { Component } from 'react';
import { isEmpty } from "lodash";
import { CardLayout, TableLayout } from '../containers/Layout';
import { TableRow, TableCell, Button, Box, Grid, Card, TableBody, TableHead, List, ListItem, Typography, Collapse, Accordion, AccordionSummary, AccordionDetails, ListItemText, IconButton, Divider, ListItemIcon, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress, Checkbox, FormControlLabel } from '@material-ui/core';
import SwipeableTabs from '../../../../commonModules/MUI/SwipeableTabs';
import Currency from '../../../../commonModules/Currency';
import { StrippedTable } from '../../../../commonModules/MUI/StrippedTable';
import { ChevronRightRounded, CloudDownloadRounded, DescriptionRounded, ExpandLess, ExpandMore, ExpandMoreRounded, MemoryRounded, ShoppingCartRounded, PhotoLibraryRounded, StorefrontRounded, SyncRounded } from '@material-ui/icons';
import Chip from '@material-ui/core/Chip';
import StockExtractButton from '../StockExtractButton';
import PopUp from '../../../../commonModules/interface/PopUp';
import Photos from '../../../../commonModules/interface/input-files';
import GridList from './GridList';
import { toast } from 'react-toastify';
import { createSubProduct, fetchSubProductsFromMainProduct } from '../../../../../../../jsx/actions/recyclingAction'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ProductCompo from './SubProducts/ProductCompo';
import SingleSubProduct from './SubProducts/SingleSubProduct';
import ProductStockList from './SubProducts/ProductStockList';
import { sanitizeEcomHtml } from '../../../../../../../jsx/utils/ecomHtml';
import { addProductPhotoLocal, refreshProductsSilently } from '../../../../../../../jsx/actions/productAction';
import EcomImageGenerator from './EcomImageGenerator';
import { summarizePhotoSync, buildSyncBody, syncErrorMessage, syncFailureMessage, ecomSyncNotice, photoFilenames } from '../../../../../../../jsx/utils/ecomPhotoSync';


class SingleProduct extends Component {
    state = {
        // Synchronisation manuelle des photos vers PrestaShop (miroir) : confirmation puis appel.
        confirmSync: false,
        // Noms des photos tels que le dialogue « Modifier » les a chargés à l'ouverture (base_photos).
        basePhotos: [],
        confirmEmpty: false,
        adoptAll: false,
        syncing: false,
        stock: [],
        AVAILABLE: [],
        PAYG: [],
        OUT: [],
        RESERVATION: [],
        OCCASION: [],
        INSTALLATION: [],
        stock_type: {value: "AVAILABLE", label: "Disponible"},
        // stock: ["", false],
        mainPhoto: 0,
        photos:[],
        URIs: [],
        updatePhotos: false,
        openGrid: false,
        SUB_PRODUCTS:[] ,
        open_desc: true,
        open_compo: false,
        openSubDetails: {},
        open_ecom: true,
        // Photos ajoutées depuis la génération IA : la fiche reçue en props vient de l'état du
        // parent et ne se met pas à jour seule, elles s'y ajoutent à l'affichage.
        photosIA: [],
    }
    componentDidMount = async () => {
        console.log("[INFO] MOUNTING PRODUCT SINGLE ");

        this.findStocks(this.props.product.id)
        this.findSales(this.props.product.product_ref, "OCCASION")
        this.findSales(this.props.product.id, "PAYG")
        this.findSales(this.props.product.id, "OUT")
        this.findSales(this.props.product.id, "RESERVATION")
        this.findSales(this.props.product.id, "INSTALLATION")
        let SUB_PRODUCTS = await this.props.fetchSubProductsFromMainProduct(this.props.product.id)
        console.log('=================SUBS LIST===================');
        console.log({SUB_PRODUCTS});
        console.log('====================================');
        this.setState({
            SUB_PRODUCTS
        })
        // this.getPhotos()
    }
    findStocks = (prodId) => {
        const { AVAILABLE, SHOPS } = this.props
        if(AVAILABLE){
            const res = Object.values(AVAILABLE).filter(
                stock => stock.product_id === prodId && stock.quantity > 0).map( 
                    stock => ( 
                    <TableRow key={stock.id} hover>
                        <TableCell>{SHOPS[stock.shop_id].name}</TableCell>
                        {/* <TableCell>{SHOPS[stock.shop_id].city}</TableCell> */}
                        <TableCell>{stock.quantity}</TableCell>
                    </TableRow>
                )
            )
            console.log("[INFO] res findStocks",res);
            this.setState({
                stock: res,
                AVAILABLE: res
            })
        }
    }
    findSales = (prodId, status) => {
        const { SHOPS, STOCKS } = this.props
        if(STOCKS[status]){
            const res = Object.values(STOCKS[status]).filter(
                stock => stock.product_id === prodId && stock.quantity > 0).map( 
                    stock => ( 
                    <TableRow key={stock.id} hover>
                        <TableCell>{SHOPS[stock.shop_id].name}</TableCell>
                        {/* <TableCell>{SHOPS[stock.shop_id].city}</TableCell> */}
                        <TableCell>{stock.quantity}</TableCell>
                    </TableRow>
                )
            )
            console.log("[INFO] res findStocks",res);
            this.setState({
                [status]: res
            })
        }
    }

    displayFields(){
        console.log("[INFO] displayFields");

        const prod = this.props.product
        const match = {
            "Garantie (Années)":prod.garantie,
            // "Marque":prod.marque,
            // "Nom":prod.name,
            "Type":prod.product_type,
            // "Prix HT":prod.prix_venteHT,
            // "Prix TTC":prod.prix_venteTTC,
            // "Référence":prod.ref,
            // " ":prod.photos,
            "Poids (Kg)":prod.poids,   
            "Largeur (mm)":prod.largeur,   
            "Longueur (mm)":prod.longueur,   
            "Hauteur (mm)":prod.hauteur, 

            "ID Fournisseur": prod.id_supplier,
            "HS Code": prod.hs_code,

            "Auto décharge": prod.bat_auto_decharge,
            "Capacité_Max(Ah)":prod.bat_max_capacity,
            "Type de batterie" :prod.bat_type,
            "Tension (V)":prod.bat_tension,
            "Nb cycles":prod.bat_nb_cycles,
            "Nb cycles à  30% de DOD":prod.bat_nb_cycles30,
            "Nb cycles à  50% de DOD":prod.bat_nb_cycles50,
            "Nb cycles à  80% de DOD":prod.bat_nb_cycles80,
            "Rendement énergétique (%)":prod.bat_rendement,            
            "Température d'exploitation":prod.bat_temperature,
            "Puissance (W) ":prod.pan_puissance,            
            "Cellules":prod.pan_cell,
            "Tension(Voc)" :prod.pan_tension,
            "Courant(Ioc)":prod.pan_courant,
            "Tension(Voc)" :prod.pan_tensionVoc,
            "Courant(Ioc)":prod.pan_courantIoc,
            "Tension(Vmpp)" :prod.pan_tensionVmpp,
            "Courant(Impp)":prod.pan_courantImpp,
            "Hauteur(mm)":prod.pan_height,
            "Largeur(mm)":prod.pan_width,
            "Profondeur(mm)":prod.pan_profondeur,
            "Rendement(%)":prod.pan_rendement,
            "Nombre de Conducteurs ":prod.cab_nb_conducteurs,
            "Section des conducteurs":prod.cab_section,
            "Type de conduits":prod.cab_type,
            "Tension de charge 'absorption'":prod.conv_absorption,
            "Courant de de charge de batterie de service (A)":prod.conv_courant_service,
            "Courant de de charge de batterie de démarrage (A)":prod.conv_courant_start,
            "Efficacité maximale":prod.conv_eff_max,
            "Tension de charge 'float' (VCC)":prod.conv_float,
            "Puissance de sortie (VA) ":prod.conv_puissance,
            "Puissance à 25°C (W) ":prod.conv_puissance25,
            "Puissance à 40°C (W) ":prod.conv_puissance40,
            "Puissance à 65°C (W)":prod.conv_puissance65,
            "Puissance crête":prod.conv_puissance_crete,
            "Type de signal":prod.conv_signal,
            "Puissance de sortie continue à 25°C (W)":prod.conv_sortie25,
            "Puissance de sortie continue à 40°C (W)":prod.conv_sortie40,
            "Tension entrée":prod.conv_tension,
            "Plage de tension d'entrée (VDC) max":prod.conv_tension_max,
            "Plage de tension d'entrée (VDC) min":prod.conv_tension_min,
            "Tension sortie nominale":prod.conv_tension_sortie,
            "Courant de Sortie Max":prod.conv_MPPT_courant_sortie,
            "Tension PV Max":prod.conv_MPPT_tensionPV_max,
            "Puissance PV Max":prod.conv_MPPT_puissancePV_max,
            
            "Tension d'entrée maximale (V)":prod.ond_tension_max,
            "Courant d'entrée maximal (A)":prod.ond_courant_entree,
            "Nombre de MPPT":prod.ond_nb_mppt,
            "Puissance active CA (W)":prod.ond_puissance_active,
            "Puissance apparente maximale (VA)":prod.ond_puissance_apparente,
            "Courant de Sortie Max (A)":prod.ond_courant_sortie,
            "Efficacité maximale (%)":prod.ond_eff_max,
            "Fréquence nominale du réseau (Hz)":prod.ond_freq,

            "Fonctionnement en triphasé":prod.conv_triphase,
            "Flux Lumineux (lm)":prod.lam_flux,
            "Puissance(W)":prod.lam_puissance,
            "Puissance(W)":prod.pomp_puissance,
            "Tension d'alimentation":prod.lam_tension,
            "Affichage":prod.reg_affichage,
            "Courant de charge nominal (V)":prod.reg_courant,
            "Puissance nominale PV 12V ":prod.reg_puissance_pv12,
            "Puissance nominale PV 24V ":prod.reg_puissance_pv24,
            "Puissance nominale PV 48V ":prod.reg_puissance_pv48,
            "Tension PV maximale en circuit ouvert":prod.reg_tension_max,
            "Type de Régulateur":prod.reg_type,
            "Type Equipement":prod.men_type,
            "Puissance à vide (W)":prod.tv_puissance_vide,
            "Puissance en Fonctionnement":prod.tv_puissance_fonc,
            "Taille (pouces)":prod.tv_taille,
            "Puissance(W)":prod.vent_puissance,
            "Autres":prod.men_infos,            
            "Description":prod.desc,            
        }
        
        return Object.keys(match).map((field, i) => {            
            if(match[field]){

                let data = match[field]
                if(Array.isArray(data)){
                    data.sort( (a, b) => {
                        return a - b;
                    })
                    data = data.join(' / ')
                }
                return(  
                    <StrippedTable key={field+i}>
                        <TableCell>{field} :</TableCell>
                        <TableCell>{data}</TableCell>
                    </StrippedTable>
                )
            }
        })
    }
    handleSubmitPhotos = async () => {
        let data = {
            photos: this.state.photos,
            base_photos: this.state.basePhotos,
            id: this.props.product.id
        }
        const ecomSync = await this.props.updatePhotosProduct(data)
        if(this.props.STATE.products.error){
            console.log("ERROR", this.props.STATE.products.error);
            
            toast.error(  this.props.STATE.products.error)
        } else{
            console.log("fetched");
            
            toast.info( "Le produit a été modifié avec succès")
            const notice = ecomSyncNotice(ecomSync)
            if (notice) toast[notice.level](notice.text)
            this.setState({
                photos: this.props.product.photos,
                updatePhotos: false
            })
        }
    }
    // handleSubmitPhotosAdd = async () => { ... }

    handlePhotoIA = (photo) => {
        if (!photo || !photo.filename) return
        this.setState({ photosIA: [...this.state.photosIA, photo] })
        this.props.addProductPhotoLocal(this.props.product, photo)
    }

    // Le dialogue part des photos actuelles de la fiche (IA comprises) : sinon il s'ouvrait
    // vide et « Valider » enregistrait une liste vide, supprimant toutes les photos.
    openPhotos = () => {
        const photos = this.photosEcom()
        this.setState({ photos, basePhotos: photoFilenames(photos), updatePhotos: true })
    }

    // Miroir des photos de la fiche vers les boutiques jumelées (POST /stocks/product/:id/photos/sync).
    syncPhotosPrestashop = async () => {
        const { product } = this.props
        this.setState({ confirmSync: false, syncing: true })
        try {
            const reponse = await fetch(`/stocks/product/${encodeURIComponent(product.id)}/photos/sync`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify(buildSyncBody(this.photosEcom().length, this.state.confirmEmpty, this.state.adoptAll)),
            })
            const corps = await reponse.json().catch(() => null)
            if (!reponse.ok) {
                toast.error(syncErrorMessage(corps, reponse.status))
                return
            }
            const { level, lines } = summarizePhotoSync(corps, reponse.status)
            // Des images ont pu être importées ou retirées de la fiche : on recharge les produits.
            if (Array.isArray(corps && corps.results) && corps.results.length > 0) this.props.refreshProductsSilently()
            const message = <div>{lines.map((l, i) => <div key={i} style={{ whiteSpace: 'pre-wrap' }}>{l}</div>)}</div>
            toast[level](message)
        } catch (e) {
            toast.error(syncFailureMessage(0, null))
        } finally {
            this.setState({ syncing: false, confirmEmpty: false, adoptAll: false })
        }
    }

    photosEcom() {
        const photos = this.props.product.photos || []
        const connues = new Set(photos.map(p => p && p.filename))
        return photos.concat(this.state.photosIA.filter(p => !connues.has(p.filename)))
    }

    displayEcomFields() {
        const prod = this.props.product
        const fields = [
            { label: "Référence (clé PS)", value: prod.ref },
            { label: "Nom produit", value: prod.name },
            { label: "Titre boutique", value: prod.product_title || prod.name },
            { label: "Récapitulatif PrestaShop", value: prod.ecom_summary, html: true },
            { label: "Description PrestaShop", value: prod.ecom_description, html: true },
            { label: "Prix HT", value: prod.prix_venteHT ? <Currency value={prod.prix_venteHT} /> : null },
            { label: "Prix TTC", value: prod.prix_venteTTC ? <Currency value={prod.prix_venteTTC} /> : null },
            { label: "TVA (%)", value: prod.tva_rate },
            { label: "Marque", value: prod.marque },
            { label: "Poids (kg)", value: prod.poids },
            { label: "Largeur (mm)", value: prod.largeur },
            { label: "Longueur (mm)", value: prod.longueur },
            { label: "Hauteur (mm)", value: prod.hauteur },
            { label: "Code douanier (HS)", value: prod.hs_code },
            { label: "Tags", value: prod.ecom_tags },
            { label: "Meta title", value: prod.ecom_meta_title },
            { label: "Meta keywords", value: prod.ecom_meta_keywords },
            { label: "Meta description", value: prod.ecom_meta_description },
            { label: "URL rewritten", value: prod.ecom_link_rewrite },
        ]
        return fields.filter(f => f.value).map((f, i) => (
            <StrippedTable key={f.label + i}>
                <TableCell>{f.label} :</TableCell>
                <TableCell>
                    {/* Le HTML stocké n'est pas digne de confiance : il peut avoir été posté
                        à l'API sans passer par l'éditeur. Il est assaini avant tout rendu. */}
                    {f.html
                        ? <div dangerouslySetInnerHTML={{ __html: sanitizeEcomHtml(f.value) }} />
                        : f.value}
                </TableCell>
            </StrippedTable>
        ))
    }
    render(){
        console.log("[STATE] PRODUCT",this.props, this.state)
        const { product } = this.props;
        const { updatePhotos, openGrid, openSubDetails } = this.state;
        const stockTypeList = [
            {value: "AVAILABLE", label: "Disponible"},
            {value: "PAYG", label: "Pay as you Go"},
            {value: "OUT", label: "Vente directes"},
            {value: "RESERVATION", label: "Réservé"},
            {value: "OCCASION", label: "Occasion"},
            {value: "INSTALLATION", label: "Installation"},
        ]
        return(
            <Box>
                {updatePhotos &&
                    <PopUp
                        close={()=> this.setState({ updatePhotos: false })}
                        submitAction={this.handleSubmitPhotos}
                        maxWidth="sm"
                        title="Modifier photos"
                        disabledSubmit={this.props.STATE.products.fetching}
                    >
                        <Box p={1}>
                            <Photos photoList={(photos) => this.setState({ photos})} photos={this.state.photos === null ? [] : this.state.photos } />
                        </Box>
                    </PopUp>
                }
                {/* {addPhotos &&
                    <PopUp
                        close={()=> this.setState({ addPhotos: false })}
                        submitAction={this.handleSubmitPhotosAdd}
                        maxWidth="sm"
                        title="Modifier photos"
                        disabledSubmit={this.props.STATE.products.fetching}
                    >
                        <Box p={1}>
                            <Photos photoList={(photos) => this.setState({ photos})} photos={this.state.photos === null ? [] : this.state.photos } />
                        </Box>
                    </PopUp>
                } */}
                {openGrid &&
                    <GridList
                        {...product}
                        handleClose={() => this.setState({ openGrid: false })}
                    />
                }
                {!isEmpty(openSubDetails) &&
                    <SingleSubProduct
                        product={openSubDetails}
                        closePopup={() => this.setState({ openSubDetails: {} })}
                    />
                }
                <Box>
                    <Box p={1} style={{textAlign: "right"}}>
                        <Button color="primary" variant="contained" onClick={this.openPhotos}>Modifier Photos</Button>
                    </Box>   
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={5}>
                            {product.photos && product.photos.length > 0 && product.photos[0].filename &&
                                <Box p={1}>
                                    <div className="thumbnail" style={{ textAlign: "center"}} >
                                        <img id="mainPhoto" style={{ maxHeight: "400px"}}  src={`/stocks/photos/${product.photos[0].filename}`} alt=""/>
                                    </div>
                                    {/* <div className="thumbnail" style={{ textAlign: "center"}} >
                                        <img id="mainPhoto" style={{ maxHeight: "400px"}}  src={product.src[this.state.mainPhoto]} alt=""/>
                                    </div> */}
                                    {/* <Grid container spacing={2}>
                                        {this.photoList()}
                                    </Grid> */}
                                </Box>
                            }
                            {!product.photos &&
                                <Box p={1}>
                                    <div className="thumbnail">
                                        <img src="img/noImg.png" alt=""/>
                                    </div>
                                </Box>
                            }
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Box p={1}>
                                <Typography variant="h5" gutterBottom>{product.name}</Typography>
                                {/* <Box>
                                    <Typography variant="h5" color="secondary"><Currency value={product.prix_venteTTC} /></Typography>
                                </Box>
                                <Typography variant="body1">Marque: <b>{product.marque}</b></Typography>
                                <Box>
                                    <Typography variant="subtitle">Référence: <b>{product.ref}</b></Typography>
                                </Box> */}
                                <Typography variant="body1" color="textSecondary" component="p">
                                    Référence: <b>{product.ref}</b>
                                </Typography>
                                {product.id_supplier && (
                                    <Typography variant="body1" color="textSecondary" component="p">
                                        Réf. fournisseur: <b>{product.id_supplier}</b>
                                    </Typography>
                                )}
                                <Typography variant="body1" color="textSecondary" component="p">
                                    Marque: <b>{product.marque}</b>
                                </Typography>
                                <Typography variant="h6" color="secondary" component="p">
                                    <b>Prix TTC: <Currency value={product.prix_venteTTC} /></b>
                                </Typography>
                                {this.props.ecomActive && <Box mt={1} mb={1}>
                                    {product.ecom_enabled
                                        ? <Chip
                                            icon={<ShoppingCartRounded />}
                                            label="Connexion Prestashop activée"
                                            color="secondary"
                                            size="small"
                                          />
                                        : <Chip
                                            icon={<ShoppingCartRounded />}
                                            label="Prestashop non connecté"
                                            variant="outlined"
                                            size="small"
                                          />
                                    }
                                </Box>}
                                <Typography variant="body1" color="textSecondary" component="p">
                                    {product.desc}
                                </Typography>
                            </Box>
                            {/* <Box p={1}>
                            </Box>    */}
                            <Box style={{display: 'flex'}}>
                                <Button
                                    onClick={() => this.setState({ openGrid: true })}
                                    color="primary"
                                >
                                    Afficher les prix
                                </Button>
                                <StockExtractButton
                                    icon={<CloudDownloadRounded />}
                                    color="primary"
                                    title="Télécharger les prix"
                                    extract="price-details-single"
                                    product_id={product.id}
                                />
                            </Box>
                            {/* <Card>
                                <TableLayout>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>
                                                <h4>Prix TTC: </h4>
                                            </TableCell>
                                            <TableCell>
                                                <h4>{new Intl.NumberFormat("fr").format(product.prix_venteTTC)} FCFA </h4>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Référence: </TableCell>
                                            <TableCell>{product.ref}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Type: </TableCell>
                                            <TableCell>{product.product_type}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Marque: </TableCell>
                                            <TableCell>{product.marque}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </TableLayout>
                            </Card> */}
                        </Grid>
                    </Grid>
                </Box>

                <Divider/>
                <Box p={1}>
                    <Card>
                        <Box p={1}>
                            <SwipeableTabs
                                labels={this.props.ecomActive && product.ecom_enabled ? ["Infos Produit", "Stocks", "E-commerce"] : ["Infos Produit", "Stocks"]}
                                default={"Infos Produit"}
                                color={"secondary"}
                            >
                                <Box>
                                    <ListItem>
                                        <ListItemIcon>
                                            <DescriptionRounded />
                                        </ListItemIcon>
                                        <ListItemText primary={"Description"} />
                                        <IconButton
                                            title="Caractéristiques du produit"
                                            onClick={ () => this.setState({
                                                open_desc: !this.state.open_desc
                                            }) } 
                                        >
                                            {this.state.open_desc ? <ExpandLess /> : <ExpandMore />}
                                        </IconButton>
                                    </ListItem>
                                    {this.state.open_desc &&
                                        <Collapse
                                            key={"desc"}
                                            in={true} 
                                            timeout="auto" 
                                            unmountOnExit
                                        >
                                            <Box p={4}>
                                                <TableLayout> 
                                                    <TableBody>
                                                        {this.displayFields()}
                                                    </TableBody>
                                                </TableLayout>
                                            </Box>
                                        </Collapse>
                                    }
                                    <Box p={1}>
                                        <Divider />
                                    </Box>
                                    <ListItem>
                                        <ListItemIcon>
                                            <MemoryRounded />
                                        </ListItemIcon>
                                        <ListItemText primary={"Composition"} />
                                        <IconButton
                                            title="Composition du produit"
                                            onClick={ () => this.setState({
                                                open_compo: !this.state.open_compo
                                            }) } 
                                        >
                                            {this.state.open_compo ? <ExpandLess /> : <ExpandMore />}
                                        </IconButton>
                                    </ListItem>
                                    {this.state.open_compo &&
                                        <Collapse
                                            key={"compo"}
                                            in={true} 
                                            timeout="auto" 
                                            unmountOnExit
                                        >
                                            <Box p={4}>
                                                <ProductCompo
                                                    list={this.state.SUB_PRODUCTS}
                                                    subDetails={(prod) => this.setState({ openSubDetails: prod})}
                                                />
                                            </Box>
                                        </Collapse>
                                    }
                                </Box>                                
                                <Box p={2}>
                                    <ProductStockList
                                        {...this.state}
                                    />
                                </Box>
                                {this.props.ecomActive && product.ecom_enabled &&
                                    <Box p={2}>
                                        {/* Récapitulatif des champs disponibles pour PrestaShop */}
                                        <ListItem>
                                            <ListItemIcon>
                                                <StorefrontRounded color="secondary" />
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={"Données e-commerce"}
                                                secondary={"Champs récupérables par PrestaShop via le connecteur"}
                                            />
                                            <IconButton
                                                onClick={() => this.setState({ open_ecom: !this.state.open_ecom })}
                                            >
                                                {this.state.open_ecom ? <ExpandLess /> : <ExpandMore />}
                                            </IconButton>
                                        </ListItem>
                                        <Collapse in={this.state.open_ecom} timeout="auto" unmountOnExit>
                                            <Box px={2} pb={2}>
                                                <TableLayout>
                                                    <TableBody>
                                                        {this.displayEcomFields()}
                                                    </TableBody>
                                                </TableLayout>
                                            </Box>
                                        </Collapse>

                                        <Box p={1}><Divider /></Box>

                                        {/* Section photos e-commerce */}
                                        <ListItem>
                                            <ListItemIcon>
                                                <PhotoLibraryRounded color="secondary" />
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={"Photos E-commerce"}
                                                secondary={"Photos visibles sur la boutique en ligne PrestaShop. Les photos sont synchronisées dans les deux sens avec vos boutiques PrestaShop : ajouts, retraits et couverture faits dans PrestaShop remontent sur la fiche. La 1re photo de la fiche est la couverture dans PrestaShop."}
                                            />
                                            <EcomImageGenerator
                                                product={{ ...product, photos: this.photosEcom() }}
                                                onPhotoAdded={this.handlePhotoIA}
                                            />
                                            <Button
                                                size="small"
                                                color="primary"
                                                disabled={this.state.syncing}
                                                startIcon={this.state.syncing ? <CircularProgress size={16} /> : <SyncRounded />}
                                                onClick={() => this.setState({ confirmSync: true, confirmEmpty: false, adoptAll: false })}
                                            >
                                                Synchroniser avec PrestaShop
                                            </Button>
                                            <Button
                                                size="small"
                                                color="primary"
                                                onClick={this.openPhotos}
                                            >
                                                Modifier
                                            </Button>
                                        </ListItem>
                                        {this.state.syncing && (
                                            <Typography variant="caption" color="textSecondary" style={{ display: 'block', textAlign: 'right', paddingRight: 16 }}>
                                                Synchronisation en cours, ne relancez pas avant le résultat (jusqu'à 3 minutes).
                                            </Typography>
                                        )}
                                        <Dialog open={this.state.confirmSync} onClose={() => this.setState({ confirmSync: false })}>
                                            <DialogTitle>Synchroniser avec PrestaShop ?</DialogTitle>
                                            <DialogContent>
                                                {this.photosEcom().length === 0
                                                    ? <React.Fragment>
                                                        <Typography style={{ color: '#c62828', fontWeight: 600 }}>
                                                            La fiche n'a aucune photo : la synchronisation SUPPRIMERA toutes les images envoyées par MyJouleBox dans les boutiques jumelées.
                                                        </Typography>
                                                        <FormControlLabel
                                                            control={<Checkbox
                                                                checked={this.state.confirmEmpty}
                                                                onChange={(e) => this.setState({ confirmEmpty: e.target.checked })}
                                                            />}
                                                            label="Je confirme la suppression"
                                                        />
                                                    </React.Fragment>
                                                    : <Typography>
                                                        PrestaShop reprendra exactement ces photos ; les images envoyées par MyJouleBox qui ne sont plus sur la fiche seront supprimées de la boutique. Les images ajoutées directement dans PrestaShop sont importées sur la fiche.
                                                    </Typography>
                                                }
                                                <FormControlLabel
                                                    control={<Checkbox
                                                        checked={this.state.adoptAll}
                                                        onChange={(e) => this.setState({ adoptAll: e.target.checked })}
                                                    />}
                                                    label="Reprendre aussi les images existantes de la boutique"
                                                />
                                                <Typography
                                                    variant="caption"
                                                    style={{ display: 'block', color: this.state.adoptAll ? '#c62828' : undefined }}
                                                    color={this.state.adoptAll ? undefined : 'textSecondary'}
                                                >
                                                    Les images ajoutées dans PrestaShop sont déjà importées sur la fiche : cette option ne retire plus que les images PrestaShop trop grosses ou au-delà de 10, qui n'ont pas pu être importées. À utiliser une fois pour aligner une boutique existante.
                                                </Typography>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={() => this.setState({ confirmSync: false })}>Annuler</Button>
                                                <Button
                                                    color="primary"
                                                    variant="contained"
                                                    disabled={this.photosEcom().length === 0 && !this.state.confirmEmpty}
                                                    onClick={this.syncPhotosPrestashop}
                                                >
                                                    Synchroniser
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                        <Box px={2} pb={2}>
                                            {this.photosEcom().length > 0
                                                ? <Grid container spacing={1}>
                                                    {this.photosEcom().map((photo, i) => (
                                                        photo.filename &&
                                                        <Grid item key={i} xs={6} sm={3}>
                                                            <img
                                                                src={`/stocks/photos/${photo.filename}`}
                                                                alt={`photo ${i + 1}`}
                                                                style={{ width: "100%", borderRadius: 4, border: "1px solid #e0e0e0" }}
                                                            />
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                                : <Typography variant="body2" color="textSecondary">
                                                    Aucune photo — utilisez "Modifier Photos" pour en ajouter.
                                                </Typography>
                                            }
                                        </Box>
                                    </Box>
                                }
                            </SwipeableTabs>
                        </Box>
                    </Card>
                </Box>
            </Box>
        )
    }
}

function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        fetchSubProductsFromMainProduct,
        addProductPhotoLocal,
        refreshProductsSilently,
    }, dispatch)
}


export default connect(mapStateToProps, mapDispatchToProps)(SingleProduct);